var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastforward = function SvgFastforward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.55 7.76 1.25 1.3c-.19-.1-.38 0-.38.2v13c0 .19.2.28.38.19l10.3-6.45c.2-.2.2-.38 0-.48",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3d4a6b",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M14.9 1.33v13"
  })));
};
export default SvgFastforward;